// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { getCities } from "countrycitystatejson";
import styled from "styled-components/macro";
// import Emage from "../atoms/emage";
import Typography from "../atoms/typography";
import Input from "../atoms/Input";
import Button from "../atoms/Button";
// import { NigerianStates } from "../utils/helpers";
import { DPIconImageUpload } from "../assets/icons";
import { useRef, useState } from "react";

interface IIsFormData {
  name: string;
  size: number;
}

export const CareerForm = () => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [resume, setResume] = useState<IIsFormData>();

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    console.log(files && files[0]);
    if (files) {
      setResume(files[0]);
    }
  };

  return (
    <Wrapper>
      <div className="careerform">
        <div>
          <Typography.Heading
            color="pending"
            weight="medium"
            level={3}
            uppercase
            fontType="Galano"
          >
            Want to join us?
          </Typography.Heading>
          <Typography.Heading
            color="darkBlue"
            weight="medium"
            level={1}
            fontType="Galano"
          >
            OUR CAREERS
          </Typography.Heading>
        </div>
        <form>
          <Input
            type="text"
            name="username"
            label="Full Name"
            placeholder="Enter Your Full Name"
          />
          <input
            onChange={handleFileUpload}
            type="file"
            style={{ display: "none" }}
            ref={fileInputRef}
          />
          {resume && (
            <Typography.Text>
              <span style={{ fontWeight: 500 }}>Uploaded</span> : {resume.name}
            </Typography.Text>
          )}
          <Button
            className="btn-resume"
            primary
            fullWidth
            onClick={() => fileInputRef && fileInputRef.current?.click()}
          >
            <DPIconImageUpload /> <span>Upload a resume</span>
          </Button>
          <Button className="landing-btn landing__btn" primary fullWidth>
            <Typography.Text weight="normal" level="xlarge">
              Submit
            </Typography.Text>
          </Button>
        </form>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  /* max-width: 500px;
  width: 90%; */
  /* display: flex;
  justify-content: center;
  align-items: center; */
  /* padding: 3rem 0; */
  display: grid;
  place-items: center;

  @media (max-width: 779px) {
    /* width: 80vw; */
    /* max-width: 500px; */
  }

  .careerform {
    /* width: 50%; */
    @media (max-width: 575px) {
      /* width: 90%; */
    }
    > * {
      margin-bottom: 2rem;
    }

    form {
      > * {
        margin-bottom: 1rem;
      }

      .btn-resume {
        background: rgba(121, 134, 159, 0.06);
        border: 0.5px solid #dee1e7;
        border-radius: 3px;
        color: #055445;

        span {
          margin-left: 1rem;
        }
      }
    }
  }
`;
